<div class="academy-progress-bar">
  <div class="progress-container"
    [ngClass]="progressClass"
    role="meter"
    [attr.aria-valuenow]="current"
    [attr.aria-valuemin]="0"
    [attr.aria-valuemax]="total"
    [attr.aria-label]="label"
    [attr.aria-valuetext]="label + ', ' + percentage + '% complete'">
    <div class="progress-fill" [style.width.%]="percentage"></div>
  </div>

  @if (showLabel || showPercentage) {
    <div class="progress-info" aria-hidden="true">
      @if (showLabel) {
        <span class="progress-label">{{ label }}</span>
      }
      @if (showPercentage) {
        <span class="progress-percentage">{{ percentage }}%</span>
      }
    </div>
  }
</div>
